/* @ngInject */
function AssetPreviewTabUsageController ($scope, $translate, $window, Utils, RepositoryService) {
  $scope.sections = [
    {
      title: $translate.instant('assetPreview.tabs.usage.sections.storedIn'),
      type: 'repository',
      cards: []
    },
    {
      title: $translate.instant('assetPreview.tabs.usage.sections.usage'),
      type: 'usage',
      cards: []
    }
  ]

  const api = {
    _loadUsage
  }
  this.getApi = () => api

  function activate () {
    api._loadUsage($scope.template.id)
  }

  $scope.$watchCollection('template', () => {
    activate()
  })

  $scope.openLocation = function (location) {
    $window.open(location.url, '_blank')
  }

  function _loadUsage (assetId) {
    $scope.sections.forEach((section) => {
      section.cards = []
    })

    return RepositoryService.getAssetUsageById(assetId).then((response) => {
      $scope.sections.forEach((section) => {
        const itemsToAddToSection = response.filter((row) => row.type === section.type)

        itemsToAddToSection.forEach((item) => {
          const card = {
            title: $translate.instant(`assetPreview.tabs.usage.modules.${item.locationName}`),
            locations: item.usages.map((usage) => {
              const url = Utils.getUsageUrlForModule({
                assetId: item.assetId,
                linkedResourceId: usage.linkedResourceId,
                locationId: usage.locationId,
                location: item.locationName
              })
              let title = usage.description

              if (item.locationName === 'repository') {
                title = usage.description || `${$translate.instant('repository.moduleTitle')}/${$translate.instant('all')}`
              } else if (item.locationName === 'publiclink') {
                title = url
              }

              return {
                title,
                url
              }
            })
          }

          section.cards.push(card)
        })
      })
    })
  }
}

export { AssetPreviewTabUsageController }
